import { render } from "./PacketsPage.vue?vue&type=template&id=26fad505"
import script from "./PacketsPage.vue?vue&type=script&lang=js"
export * from "./PacketsPage.vue?vue&type=script&lang=js"

import "./PacketsPage.vue?vue&type=style&index=0&id=26fad505&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__